import React, { useEffect, useState } from "react";

import { Button, List, Segmented, Table } from "antd";
import { MainTable } from "components";
function ServiceTable({ data, className = "", title, servicetypeid }) {
  const [viewMode, setViewMode] = useState("table");
  const [totalCount, setTotal] = useState(
    0
    // data.reduce((a, b) => a.cnt + b.cnt, 0)
  );
  // const [data, setData] = useState(dataService); ///data.reduce((a, b) => a.cnt + b.cnt, 0);

  const columns = [
    {
      title: "Нэр",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Тоо",
      dataIndex: "cnt",
      key: "cnt",
      render: (text, row) => <div>{Intl.NumberFormat().format(text)} </div>,
      sorter: (a, b) => a.cnt - b.cnt,
    },
    {
      title: "Хувь",
      dataIndex: "cnt",
      key: "cnt",
      //   sorter: (a, b) => a.cnt - b.cnt,
      render: (cnt, row) => (
        <div>
          {(
            (cnt * 100) /
            (servicetypeid == 1 ? row.mriTotal : row.ctTotal)
          ).toFixed(2) + "%"}
        </div>
      ),
    },
  ];
  return (
    <div
      className={` bg-white rounded-lg shadow p-3 flex flex-col ${className}`}
    >
      <div className="flex gap-5">
        <div className="border rounded-lg overflow-hidden flex-1">
    
          <MainTable
            dataTable={
              data ? data.filter((x) => x.servicetypeid == servicetypeid) : []
            }
            columns={columns}
            title={title}
          />
        </div>
      </div>
    </div>
  );
}

export default ServiceTable;
